import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=2f60f14e"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports